module.exports = __webpack_public_path__ + "assets/img/zbcgbg2.b6a37e78.png";